'use client';

import {
  DataTypesSlider,
  DataTypesSliderProps,
} from '@components/dataTypesSlider';
import { memo } from 'react';

export const DataTypesSection = memo(
  ({
    slides,
    imagesDataMap,
  }: Omit<DataTypesSliderProps, 'customSliderClasses'>) => {
    return (
      <DataTypesSlider
        slides={slides}
        imagesDataMap={imagesDataMap}
        customSliderClasses="!px-4"
        imageContainerHeight={740}
      />
    );
  },
);
